import axios from "axios";
const url = "https://api.jivini.in";

export const api = axios.create({
  baseURL: url,
  timeout: 60000,
  // maxContentLength: 52428800,
  headers: { "Content-Type": "application/json" },
});
